module.exports = {
  style: '3d',
  autoplay: {
    ifAutoplay: true,
    delay: 3
  },
  navigation: {
    ifShow: false,
    color: '#ffffff',
    size: 40
  },
  pagination: {
    ifShow: false,
    color: '#ffffff',
    size: 16,
    position: 'center'
  },
  androidNoSwiping: false,
  iosNoSwiping: false,
  list: [
    {
      img: require('./Images/wmdxsd.jpg'),
      jumpUrl: 'https://activity.kugou.com/match/v-b15a20b0/index.html'
    },/* 
    {
      img: require('./Images/yygq.png'),
      jumpUrl: 'https://activity.kugou.com/match/v-ddc3b44a/index.html'
    }, */
    {
      img: require('./Images/scxf.jpg'),
      jumpUrl: 'https://activity.kugou.com/voo/v-4baebf7e/index.html'
    },
    {
      img: require('./Images/wmdxsd.png'),
      jumpUrl: 'https://activity.kugou.com/voo/v-26cea50e/index.html'
    },
    {
      img: require('./Images/wmdgsstk.jpg'),
      jumpUrl: 'https://m3ws.kugou.com/mtpls/topic/6188fbfcdea80bfdd3a7df7d.html'
    },
    {
      img: require('./Images/crysqgsc.jpg'),
      jumpUrl: 'https://activity.kugou.com/voo/v-0e330a46/index.html'
    },
    {
      img: require('./Images/ssqgzyh.jpg'),
      jumpUrl: 'https://activity.kugou.com/voo/v-d5ec9d30/index.html'
    },
    {
      img: require('./Images/qzyl.jpg'),
      jumpUrl: 'https://m3ws.kugou.com/mtpls/topic/616f9445dea80b7b8ca7df9b.html'
    },
    {
      img: require('./Images/kggcyyj.jpg'),
      jumpUrl: 'https://m3ws.kugou.com/mtpls/topic/619c55b6dea80bd78d074ff1.html'
    },
    {
      img: require('./Images/ww.jpg'),
      jumpUrl: 'https://m3ws.kugou.com/mtpls/topic/6183454adea80b773aa7df77.html'
    },
    {
      img: require('./Images/yxzg.jpg'),
      jumpUrl: 'https://activity.kugou.com/voo/v-4eec18ca/index.html'
    },
    {
      img: require('./Images/ssy.jpg'),
      jumpUrl: 'https://activity.kugou.com/voo/v-ec9b2efe/index.html'
    },
  ],
};
